module.exports = __webpack_public_path__ + "static/img/home_logo.ba8c150.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home_logo.png
// module id = 5bpU
// module chunks = 1